const PreparePackageItemListTypes = {
    TODO: 0,
    DONE: 1,
    ALL: 2
};

export {PreparePackageItemListTypes};
